import React from 'react';
import ProductOptionGrid from './ProductOptionGrid';

const MastercardProductOptionGridHelper = () => {
  const productOptionItems = [
    {
      title: 'Digital Delivery',
      description: 'Deliver it straight to their inbox and send a digital Mastercard to anyone, anywhere, instantly!',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0569/2027/7158/files/Digital_Delivery.jpg?v=1634871344',
    },
    {
      title: 'Physical Gift Card',
      description: 'Deliver it in-person and have it all wrapped up with a physical gift card',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0569/2027/7158/files/Physical_Gift_Card.jpg?v=1634871344',
    },
    {
      title: 'A Personal Touch',
      description: 'Make it personal and upload your own design, photo or video message',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0569/2027/7158/files/A_Personal_Touch.jpg?v=1634871344',
    },
    {
      title: 'Corporate Customisation',
      description: 'Something to say thanks to the team? Upload your own image or add your company logo to make it yours',
      imgUrl: 'https://cdn.shopify.com/s/files/1/0569/2027/7158/files/Corporate_Customisation.jpg?v=1634871344',
    },
  ];
  return <ProductOptionGrid items={productOptionItems} noCursor />;
};

export default MastercardProductOptionGridHelper;
